// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toaster {
    position: fixed;
    top: 20px;
    right: 20px;
    /* bottom: 20px; */
    max-height: 100%;
    z-index: 9999;
}

.toast {
    display: flex;
    align-items: center;    
    padding: 12px 8px 12px 16px;
    margin-bottom: 10px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    /* border-bottom-width: 4px; */
    border-bottom-width: 0.3125rem}

.toast svg {
    flex-shrink: 0;
    /* width: 1.25rem;
    height: 1.25rem; */
}

.toast button svg {
    width: 0.75rem;
    height: 0.75rem;
}

.toast h6 {
    margin-inline-start: 0.75rem;
    font-size: 1.125rem;
    font-weight: 500;
    line-height: 1.25;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
}

.toast.error {
    --tw-text-opacity: 1;
    color: rgb(155 28 28 / var(--tw-text-opacity));
    --tw-border-opacity: 1;
    border-color: rgb(248 180 180 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(253 242 242 / var(--tw-bg-opacity));
}

.toast.success {
    --tw-text-opacity: 1;
    color: rgb(3 84 63 / var(--tw-text-opacity));
    --tw-border-opacity: 1;
    border-color: rgb(132 225 188 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(243 250 247 / var(--tw-bg-opacity));
}

.toast.warning {
    --tw-text-opacity: 1;
    color: rgb(138 44 13 / var(--tw-text-opacity));
    --tw-border-opacity: 1;
    border-color: rgb(253 186 140 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(255 248 241 / var(--tw-bg-opacity));
}

.toast.info {
    --tw-text-opacity: 1;
    color: rgb(30 66 159 / var(--tw-text-opacity));
    --tw-border-opacity: 1;
    border-color: rgb(164 202 254 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(235 245 255 / var(--tw-bg-opacity));
}

.toast button {
    margin-inline-start: auto;
    font-weight: bold;
    cursor: pointer;
    padding: 0.375rem;
    border-radius: 0.5rem;
    display: inline-flex;
    height: 2rem;
    width: 2rem;
    align-items: center;
    justify-content: center;
}

.toast button.success:hover {
    background-color: rgb(243 250 247 / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: rgb(14 159 110 / var(--tw-text-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(188 240 218 / var(--tw-bg-opacity));
}

.toast button.success:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(49 196 141 / var(--tw-ring-opacity));
}

.toast button.error:hover {
    background-color: rgb(253 242 242 / var(--tw-bg-opacity));
    --tw-text-opacity: 1;
    color: rgb(240 82 82 / var(--tw-text-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(251 213 213 / var(--tw-bg-opacity));
}

.toast button.error:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity));
}`, "",{"version":3,"sources":["webpack://./src/styles/toaster.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,8BAA8B;IAC9B,8BACJ;;AAEA;IACI,cAAc;IACd;sBACkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAGI;IAAA,4BAAwD;IAAxD,mBAAwD;IAAxD,gBAAwD;IAAxD,iBAAwD;IAAxD,oBAAwD;IAAxD;AAAwD;;AAG5D;IACI,oBAAoB;IACpB,8CAA8C;IAC9C,sBAAsB;IACtB,yDAAyD;IACzD,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,oBAAoB;IACpB,4CAA4C;IAC5C,sBAAsB;IACtB,yDAAyD;IACzD,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,oBAAoB;IACpB,8CAA8C;IAC9C,sBAAsB;IACtB,yDAAyD;IACzD,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,oBAAoB;IACpB,8CAA8C;IAC9C,sBAAsB;IACtB,yDAAyD;IACzD,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IAEI,yDAAyD;IACzD,oBAAoB;IACpB,+CAA+C;IAC/C,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,oBAAoB;IACpB,yDAAyD;AAC7D;;AAEA;IAEI,yDAAyD;IACzD,oBAAoB;IACpB,8CAA8C;IAC9C,kBAAkB;IAClB,yDAAyD;AAC7D;;AAEA;IACI,oBAAoB;IACpB,0DAA0D;AAC9D","sourcesContent":[".toaster {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    /* bottom: 20px; */\n    max-height: 100%;\n    z-index: 9999;\n}\n\n.toast {\n    display: flex;\n    align-items: center;    \n    padding: 12px 8px 12px 16px;\n    margin-bottom: 10px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    /* border-bottom-width: 4px; */\n    @apply border-b-5\n}\n\n.toast svg {\n    flex-shrink: 0;\n    /* width: 1.25rem;\n    height: 1.25rem; */\n}\n\n.toast button svg {\n    width: 0.75rem;\n    height: 0.75rem;\n}\n\n.toast h6 {\n    @apply ms-3 font-5 text-18 text-darkGrayClr leading-tight\n}\n\n.toast.error {\n    --tw-text-opacity: 1;\n    color: rgb(155 28 28 / var(--tw-text-opacity));\n    --tw-border-opacity: 1;\n    border-color: rgb(248 180 180 / var(--tw-border-opacity));\n    --tw-bg-opacity: 1;\n    background-color: rgb(253 242 242 / var(--tw-bg-opacity));\n}\n\n.toast.success {\n    --tw-text-opacity: 1;\n    color: rgb(3 84 63 / var(--tw-text-opacity));\n    --tw-border-opacity: 1;\n    border-color: rgb(132 225 188 / var(--tw-border-opacity));\n    --tw-bg-opacity: 1;\n    background-color: rgb(243 250 247 / var(--tw-bg-opacity));\n}\n\n.toast.warning {\n    --tw-text-opacity: 1;\n    color: rgb(138 44 13 / var(--tw-text-opacity));\n    --tw-border-opacity: 1;\n    border-color: rgb(253 186 140 / var(--tw-border-opacity));\n    --tw-bg-opacity: 1;\n    background-color: rgb(255 248 241 / var(--tw-bg-opacity));\n}\n\n.toast.info {\n    --tw-text-opacity: 1;\n    color: rgb(30 66 159 / var(--tw-text-opacity));\n    --tw-border-opacity: 1;\n    border-color: rgb(164 202 254 / var(--tw-border-opacity));\n    --tw-bg-opacity: 1;\n    background-color: rgb(235 245 255 / var(--tw-bg-opacity));\n}\n\n.toast button {\n    margin-inline-start: auto;\n    font-weight: bold;\n    cursor: pointer;\n    padding: 0.375rem;\n    border-radius: 0.5rem;\n    display: inline-flex;\n    height: 2rem;\n    width: 2rem;\n    align-items: center;\n    justify-content: center;\n}\n\n.toast button.success:hover {\n    --tw-bg-opacity: 1;\n    background-color: rgb(243 250 247 / var(--tw-bg-opacity));\n    --tw-text-opacity: 1;\n    color: rgb(14 159 110 / var(--tw-text-opacity));\n    --tw-bg-opacity: 1;\n    background-color: rgb(188 240 218 / var(--tw-bg-opacity));\n}\n\n.toast button.success:focus {\n    --tw-ring-opacity: 1;\n    --tw-ring-color: rgb(49 196 141 / var(--tw-ring-opacity));\n}\n\n.toast button.error:hover {\n    --tw-bg-opacity: 1;\n    background-color: rgb(253 242 242 / var(--tw-bg-opacity));\n    --tw-text-opacity: 1;\n    color: rgb(240 82 82 / var(--tw-text-opacity));\n    --tw-bg-opacity: 1;\n    background-color: rgb(251 213 213 / var(--tw-bg-opacity));\n}\n\n.toast button.error:focus {\n    --tw-ring-opacity: 1;\n    --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
